module.exports = __webpack_public_path__ + "static/media/hugged.fbed7a07.jpg";